module.exports = __webpack_public_path__ + "img/grxx_zt_2.c027b70d.svg";